if (!customElements.get('show-more-description')) {
  customElements.define(
    'show-more-description',
    class ShowMoreDescription extends HTMLElement {
      #initialized = false;

      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.#initialized) return;

        const content = this.querySelector('[data-description-content]');
        const button = this.querySelector('[data-show-more-btn]');
        const showLessText = this.dataset.showLessText || 'Show Less';
        const showMoreText = this.dataset.showMoreText || 'Show More';

        if (!content || !button) return;

        if (content.scrollHeight === 0) return;

        if (content.scrollHeight <= 130) {
          this.#initialized = true;
          return;
        }

        this.#initialized = true;
        button.style.display = 'block';

        button.addEventListener('click', () => {
          const isExpanded = content.classList.toggle('expanded');
          button.textContent = isExpanded ? showLessText : showMoreText;
        });
      }
    }
  );
}
